import React from 'react';
import { NavLink } from 'react-router-dom';

import block from 'propmods';
import { hrefIsExternal } from '../../utils';

import './Link.scss';

const b = block('Link');

interface LinkProps {
    icon?: string;
    external?: boolean;
    exact?: boolean;
    to: string;
}

export default function Link(props: LinkProps & React.HTMLProps<HTMLAnchorElement>) {
    const { icon, external, to, children, exact, ...rest } = props;
    const cn = b({ hasIcon: icon !== void 0 });
    const style = { backgroundImage: '' };
    if (icon) {
        style.backgroundImage = 'url(' + icon + ')';
    }

    if (typeof to === 'string' && (external || hrefIsExternal.test(to))) {
        return (
            <a {...cn} href={to} rel="noopener noreferrer" {...rest}>
                {icon && <div {...b('icon')} style={style} />}
                {children}
            </a>
        );
    }

    return (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <NavLink {...cn} activeClassName="Link_active" exact={exact} to={to} {...(rest as any)}>
            {icon && <div {...b('icon')} style={style} />}
            {children}
        </NavLink>
    );
}

export const StoreLink: React.FC = (props) => <Link to={__appConfig.app.storeUrl} target="_blank" {...props} />;
